module.exports = __webpack_public_path__ + "img/resp_text_small2.ec9eb670.png";